import React from "react";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";
import { FormControl } from "@mui/material";
import { FormLabel } from "@mui/material";
import { RadioGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { Radio } from "@mui/material";
import "./PlanStatus.css";
import { Button } from "@mui/material";
import Ativo from "../../../imgs/icons/planoPagamento/Ativo.svg";
import Suspenso from "../../../imgs/icons/planoPagamento/Suspenso.svg";
import { useEffect, useState } from "react";
import { AssociatedType } from "../../../enumerations/Associated/associatedType";
import { SubscriptionPlanType } from "../../../enumerations/Associated/subscriptionPlanType";
import { PaymentForm } from "../../../enumerations/OrderSale/paymentForm";
import jwt_decode from "jwt-decode";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";
import { findBySubscriptionPlanType } from "../../../services/subscriptionPlanService";
import { Document, Page,pdfjs } from 'react-pdf';
import {
  sendOrderSale,
  removeOrderSale,
  findByTransaction,
  findByAssociatedId,
} from "../../../services/orderSaleService";
import {
  checkRecurrenceActive,
  cancelRecurrence,
} from "../../../services/recurrence";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "./fonteSourceSansPro.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import adeptTerms from '../../../docs/adeptterm.pdf'
pdfjs.GlobalWorkerOptions.workerSrc ='pdf.worker.js';

export default function PlanStatus() {
  const [active, setActive] = useState(true);
  const [associatedId, setAssociatedId] = useState(undefined);
  const [customerCode, setCustomerCode] = useState(undefined);
  const [subscriptionPlanId, setSubscriptionPlanId] = useState(undefined);
  const [subscriptionPlanType, setSubscriptionPlanType] = useState(undefined);
  const [initialDate, setInitialDate] = useState(undefined);
  const [expirationDate, setExpirationDate] = useState(undefined);
  const [subscriptionPlanData, setSubscriptionPlanData] = useState([]);
  const [valuePlan, setValuePlan] = useState(undefined);
  const [paymentLink, setPaymentLink] = useState(undefined);
  const [paid, setPaid] = useState(false);
  const [loadingBackdrop, setLoadingBackdrop] = useState(false);
  const [recurrenceActive, setRecurrenceActive] = useState(false);

  const [numPages, setNumPages] = React.useState(0);

  const [open, setOpen] = React.useState(false);
  const [openModalTerms, setOpenModalTerms] = React.useState(false);

  const handleClose = () => setOpen(false);
  const handleCloseModalTerms = () => setOpenModalTerms(false);

  const handleOpen = () => setOpen(true);


  useEffect(() => {
    setLoadingBackdrop(true);
    const token = localStorage.getItem("jwt_auth");
    const currentDate = moment().format("YYYY-MM-DDTHH:mm:ss");
    const { id, associatedCode, associatedTypeId, planoAssinatura } =
      jwt_decode(token);

    setAssociatedId(id);
    setCustomerCode(associatedCode);

    if (
      currentDate > planoAssinatura.dataTerminoVigencia ||
      planoAssinatura.subscriptionPlanTypeId === SubscriptionPlanType.FREE
    ) {
      if (currentDate > planoAssinatura.dataTerminoVigencia) {
        setActive(false);
      }

      const subscriptionPlanTypeId =
        associatedTypeId === AssociatedType.PARTICIPANT
          ? SubscriptionPlanType.PARTICIPANT
          : SubscriptionPlanType.CONTRIBUTOR;

      getSubscriptionPlanType(subscriptionPlanTypeId);
    }
    setSubscriptionPlanType(planoAssinatura.subscriptionPlanTypeId);
    setInitialDate(planoAssinatura.dataInicioVigencia);
    setExpirationDate(planoAssinatura.dataTerminoVigencia);

    getOrderSalesByAssociatedId(id);
    checkExistRecurrenceActive(id);
  }, []);

  async function getSubscriptionPlanType(subscriptionPlanTypeId) {
    findBySubscriptionPlanType(subscriptionPlanTypeId).then(({ data }) => {
      setSubscriptionPlanData(data);
    });
  }

  function openModalTermsPop(e) {
    setOpenModalTerms(true)
  }
  async function getOrderSalesByAssociatedId(associatedId) {
    await findByAssociatedId(associatedId).then(({ data }) => {
      setPaymentLink(data.paymentLink);
      setPaid(data.paid);
      setLoadingBackdrop(false);
    });
  }

  async function checkExistRecurrenceActive(associatedId) {
    await checkRecurrenceActive(associatedId).then(({ data }) => {
      setRecurrenceActive(data);
    });
  }

  function delay(t) {
    return new Promise((resolve) => {
      setTimeout(resolve, t);
    });
  }

  async function tryFetchTransaction(
    transactionId,
    currentTry = 0,
    maxRetries = 3
  ) {
    await delay(10000);
    await findByTransaction(transactionId)
      .then(async (data) => {
        if (data?.data?.status === false) {
          if (currentTry < maxRetries) {
            await tryFetchTransaction(
              transactionId,
              currentTry + 1,
              maxRetries
            );
          } else {
            await removeOrderSale(transactionId);
            toast.error(
              "Não foi possível processar sua solicitação. Por favor tente mais tarde"
            );
          }
        } else {
          await getOrderSalesByAssociatedId(associatedId);
        }
      })
      .catch(async (err) => {
        err.response.data.errors.forEach((error) => {
          console.log(error);
        });
        toast.error(
          "Sistema indisponível no momento. Por favor tente mais tarde"
        );
      });
  }

  const handleCancelRecurrence = async () => {
    setLoadingBackdrop(true);
    await cancelRecurrence(associatedId)
      .then(async (res) => {
        toast.success("Recorrência cancelada com sucesso");
        handleClose();
        checkExistRecurrenceActive(associatedId);;
      })
      .catch((err) => {
        if (err.response) {
          err.response.data.errors.forEach((error) => {
            console.log(error);
          });
          toast.error(
            "Erro ao cancelar a recorrência. Por favor tente mais tarde"
          );
          handleClose();
        }
      })
      .finally(() => {
        setLoadingBackdrop(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      radioPlans: "",
      createAcceptTerms: false,
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      console.log(values.createAcceptTerms)
      if(!values.createAcceptTerms){
        toast.error(
          "É necessário aceitar os termos para prosseguir."
        );
        return;
      }
      setLoadingBackdrop(true);
      await sendOrderSale({
        customerCode,
        subscriptionPlanId,
        messageForNote: `Compra via ${PaymentForm.CREDIT_CARD}`,
        formPayment: PaymentForm.CREDIT_CARD,
        products: [
          {
            productId: values.radioPlans,
            value: valuePlan,
          },
        ],
      })
        .then(async (response) => {
          await tryFetchTransaction(response.data.transactionId, 0);
        })
        .catch((err) => {
          if (err.response) {
            err.response.data.errors.forEach((error) => {
              console.log(error);
            });
            toast.error(
              "Sistema indisponível no momento. Por favor tente mais tarde"
            );
          }
        })
        .finally(() => {
          setLoadingBackdrop(false);
        });
    },
  });

  return (
    <>

<Dialog
        open={openModalTerms}
        onClose={handleCloseModalTerms}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: { borderRadius: 25,width:800 },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1400px",  // Set your width here
            },
          },
        }}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" style={{height:50}}>
          {handleCloseModalTerms ? (
            <IconButton
              aria-label="close"
              onClick={handleCloseModalTerms}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[600],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent style={{width:'100%'}} >

      <Document  file={adeptTerms}    onLoadSuccess={({ numPages })=>setNumPages(numPages)}
  onLoadError={console.error} options={{workerSrc: "pdf.worker.js"}}>

        {Array.apply(null, Array(numPages))
    .map((x, i)=>i+1)
    .map(page => <Page  scale={1.25} renderTextLayer={false}
      renderAnnotationLayer={false}
      customTextRenderer={false}  pageNumber={page}/>)}
      </Document>
      {/* <p>
        Page {pageNumber} of {numPages}
      </p> */}

        </DialogContent>
        <DialogContentText sx={{ height: 150 }} align="center">
        <Button
            sx={{
              marginTop:1,
              marginBottom:2,
              bgcolor: "#58C5C6",
              color: "#fff",
              textTransform: "none !important",
              width: "25%",
              fontFamily: "Source Sans Pro",
              "&:hover": {
                bgColor: "#fff",
                color: "#58C5C6",
                border: "1px solid #58C5C6",
              },
            }}
            onClick={handleCloseModalTerms}
          >
            OK
          </Button>

        </DialogContentText>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: { borderRadius: 25 },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography
            variant="h5"
            align="center"
            sx={{
              fontWeight: "bold",
              color: "#ed2d53",
              marginTop: 3,
              marginBottom: 3,
            }}
          >
            Cancelamento
          </Typography>
          {handleClose ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[600],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" align="center">
            Ao cancelar a sua assinatura recorrente, você <br /> descontinuará
            tudo que construiu com a gente até aqui. <br />
            Para voltar a utilizar o portal, você precisará efetuar
            <br /> o pagamento novamente.
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            align="center"
            sx={{ marginTop: 3 }}
          >
            Deseja cancelar o pagamento recorrente?
          </DialogContentText>
        </DialogContent>
        <DialogContentText sx={{ height: 75 }} align="center">
          <Button
            sx={{
              bgcolor: "#7B7B7B",
              color: "#fff",
              textTransform: "none !important",
              width: "25%",
              fontFamily: "Source Sans Pro",
              "&:hover": {
                bgColor: "#fff",
                color: "#7B7B7B",
                border: "1px solid rgba(135, 135, 135, 1)",
              },
            }}
            onClick={handleClose}
          >
            NÃO
          </Button>
          <Button
            sx={{
              marginLeft: "20px",
              bgcolor: "#ed2d53",
              color: "#fff",
              textTransform: "none !important",
              width: "25%",
              fontFamily: "Source Sans Pro",
              "&:hover": {
                bgColor: "#fff",
                color: "#ed2d53",
                border: "1px solid #ed2d53",
              },
            }}
            onClick={handleCancelRecurrence}
            autoFocus
          >
            SIM
          </Button>
        </DialogContentText>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingBackdrop}
        >
          <CircularProgress color="inherit" />{" "}
        </Backdrop>
      </Dialog>

      <Box>
        <Grid container spacing={0} columns={16} width="381px">
          <Grid item xs={16}>
            <Box
              sx={{
                fontSize: "32px",
                marginBottom: "30px",
                fontFamily: "Source Sans Pro",
                color: "#7B7B7B",
              }}
            >
              Plano/Pagamento
            </Box>
          </Grid>
          <Grid item xs={12}>
            <p
              style={{
                marginBottom: "0",
                fontFamily: "Source Sans Pro",
                fontSize: "18px",
                color: "#7B7B7B",
              }}
            >
              Status do plano:
            </p>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                height: "50px",
                alignItems: "center",
              }}
            >
              {active ? (
                <>
                  <img src={Ativo} />
                  <p
                    style={{
                      color: "#0CBA90",
                      marginBottom: "0",
                      paddingLeft: "7px",
                      fontFamily: "Source Sans Pro",
                    }}
                  >
                    <span style={{ color: "#0CBA90" }}>ATIVO</span>
                  </p>
                </>
              ) : (
                <>
                  <img src={Suspenso} />
                  <p
                    style={{
                      color: "#0CBA90",
                      marginBottom: "0",
                      paddingLeft: "7px",
                      fontFamily: "Source Sans Pro",
                    }}
                  >
                    <span style={{ color: "#D70F57" }}>SUSPENSO</span>
                  </p>
                </>
              )}
            </Box>
          </Grid>
          <Grid item xs={16}>
            <hr style={{ marginTop: "0" }}></hr>
          </Grid>
          {active && subscriptionPlanType !== SubscriptionPlanType.FREE ? (
            <Grid item xs={16}>
              <p style={{ fontFamily: "Source Sans Pro", color: "#7B7B7B" }}>
                <b style={{ fontFamily: "Source Sans Pro", color: "#7B7B7B" }}>
                  Você tem o acesso aos recursos do Portal desde
                </b>{" "}
                {moment(initialDate).format("DD/MM/YYYY")}
                <br />
                <br />
                Acesse até {moment(expirationDate).format("DD/MM/YYYY")}
              </p>
              {recurrenceActive ? (
                <span>
                  <Button
                    type="submit"
                    sx={{
                      marginTop: "20px",
                      bgcolor: "#E74C3C",
                      color: "#fff",
                      textTransform: "none !important",
                      width: "90%",
                      fontFamily: "Source Sans Pro",
                      "&:hover": {
                        bgColor: "#fff",
                        color: "#E74C3C",
                        border: "1px solid #E74C3C",
                      },
                    }}
                    onClick={() => {
                      handleOpen();
                    }}
                  >
                    Cancelar Assinatura
                  </Button>
                </span>
              ) : (
                <></>
              )}
            </Grid>
          ) : active && subscriptionPlanType === SubscriptionPlanType.FREE ? (
            <Grid item xs={16}>
              <p style={{ fontFamily: "Source Sans Pro", color: "#7B7B7B" }}>
                <b style={{ fontFamily: "Source Sans Pro", color: "#7B7B7B" }}>
                  Você tem o acesso aos recursos do Portal desde
                </b>{" "}
                {moment(initialDate).format("DD/MM/YYYY")}
                <br />
                <br />
                <b style={{ fontFamily: "Source Sans Pro" }}>
                  Assinatura temporária gratuita por 1 mês
                </b>
                <br />
                Acesse até {moment(expirationDate).format("DD/MM/YYYY")}
              </p>
            </Grid>
          ) : (
            <Grid item xs={16}>
              <p style={{ fontFamily: "Source Sans Pro" }}>
                A sua assinatura está suspensa. Escolha uma das opções abaixo e
                volte a utilizar os recursos do Portal do MEI. Em caso de
                dúvidas, entre em contato:
                <b style={{ fontFamily: "Source Sans Pro" }}>
                  <a href="mailto:portaldomei@acsp.com.br">
                    portaldomei@acsp.com.br
                  </a>
                </b>
                <br></br>
              </p>
            </Grid>
          )}

          {paymentLink === undefined ? (
            <form onSubmit={formik.handleSubmit}>
              {!active || subscriptionPlanType === SubscriptionPlanType.FREE ? (
                <Grid item xs={16}>
                  <br></br>
                  <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">
                      <p
                        style={{
                          marginBottom: "0",
                          fontFamily: "Source Sans Pro",
                          color: "#7B7B7B",
                        }}
                      >
                        Escolha do plano:
                      </p>
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="Mensal"
                      onChange={formik.handleChange}
                      name="radioPlans"
                      value={formik.values.inCompliance}
                    >
                      {subscriptionPlanData.map((data, key) => (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                          key={key}
                        >
                          <FormControlLabel
                            value={data.code}
                            control={
                              <Radio
                                required={true}
                                sx={{
                                  color: "#7B7B7B",
                                  "&.Mui-checked": {
                                    color: "#58C5C6",
                                  },
                                }}
                              />
                            }
                            sx={{
                              marginBottom: "0",
                            }}
                            onChange={() => {
                              setSubscriptionPlanId(data.id);
                              setValuePlan(data.price);
                            }}
                          />
                          <p
                            style={{
                              marginBottom: "0",
                              marginLeft: "-15px",
                              fontFamily: "Source Sans Pro",
                            }}
                          >
                            {data.name} /{" "}
                            <b style={{ fontFamily: "Source Sans Pro" }}>
                              R$ {data.price.replace(".", ",")}
                            </b>
                            {data.name === "Anual" ? (
                              <span
                                style={{
                                  fontFamily: "Source Sans Pro",
                                  color: "#0CBA90",
                                }}
                              >
                                {" "}
                                (Você economiza R$ 20,28)
                              </span>
                            ) : (
                              <></>
                            )}
                          </p>
                        </Box>
                      ))}
                    </RadioGroup>

                    <FormControlLabel
                            onChange={(e) =>
                              formik.setFieldValue(
                                "createAcceptTerms",
                                e.target.checked
                              )
                            }
                          checked={formik.values.createAcceptTerms}
                          control={<Checkbox   name="createAcceptTerms" />}
                          value={formik.values.createAcceptTerms}
                          label={
                            <div>
                              <font color="#002C43">Eu li e concordo com o</font>{" "}
                              <a onClick={() =>  openModalTermsPop(true)}>
                                {" "}
                                <font color="#58C5C6">
                                Termo de Adesão
                                </font>
                              </a>
                            </div>
                          }
                        />
                  </FormControl>

                  <span>
                    {valuePlan > SubscriptionPlanType.FREE && formik.values.createAcceptTerms ? (
                      <span>
                        <Button
                          type="submit"
                          sx={{
                            marginTop: "20px",
                            bgcolor: "#58C5C6",
                            color: "#fff",
                            textTransform: "none !important",
                            width: "90%",
                            fontFamily: "Source Sans Pro",
                            "&:hover": {
                              bgColor: "#fff",
                              color: "#58C5C6",
                              border: "1px solid #58C5C6",
                            },
                          }}

                        >
                          {/* Assinar */}
                          Solicitar pagamento
                        </Button>
                      </span>
                    ) : (
                      <span>
                        <Button
                          type="submit"
                          sx={{
                            marginTop: "20px",
                            bgcolor: "#7B7B7B",
                            color: "#fff",
                            textTransform: "none !important",
                            width: "90%",
                            fontFamily: "Source Sans Pro",
                            "&:hover": {
                              bgColor: "#fff",
                              color: "#7B7B7B",
                              border: "1px solid rgba(135, 135, 135, 1)",
                            },
                          }}
                        >
                          {/* Assinar */}
                          Solicitar pagamento
                        </Button>
                      </span>
                    )}
                  </span>
                </Grid>
              ) : (
                <></>
              )}
            </form>
          ) : !paid ? (
            <Grid item xs={16}>
              <hr style={{ marginTop: "0" }}></hr>
              <p
                style={{
                  marginBottom: "0",
                  fontFamily: "Source Sans Pro",
                  fontSize: "18px",
                }}
              >
                Status do pagamento:
              </p>
              <br />
              <p style={{ fontFamily: "Source Sans Pro" }}>
                <b style={{ fontFamily: "Source Sans Pro" }}>
                  Pendente de pagamento
                </b>
              </p>
              <p style={{ fontFamily: "Source Sans Pro" }}>
                Link para pagamento{" "}
                <a href={paymentLink} target="_blank" rel="noreferrer">
                  {paymentLink}
                </a>
              </p>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingBackdrop}
      >
        <CircularProgress color="inherit" />{" "}
      </Backdrop>
    </>
  );
}
